module.exports = __webpack_public_path__ + "static/media/importFlybook4.de0d8039.png";